import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Title from "../../Text/Title/Title";
import { SubTitle } from "../../Text/Subtitle/SubTitle";
import useApiRequests from "../../../hooks/useApiRequests.tsx";
import { ITool } from "../../../interfaces/ITool.tsx";
import { Button, Form, Row, Col, Input, FormGroup, Label } from "reactstrap";
import { useNotification } from "../../../hooks/useNotification";

function ToolsEdit() {
  const { notify } = useNotification();
  const navigate = useNavigate();
  const { id } = useParams();
  const { getToolById, createNewTool, updateTool } = useApiRequests();
  const [tool, setTool] = useState<ITool>({
    name: "",
  });

  useEffect(() => {
    const getTask = async () => {
      try {
        const taskData = await getToolById(id || "");
        if (taskData.success) {
          setTool(taskData.data);
        } else {
          notify(taskData.msg, { type: "error" });
        }
      } catch (error) {
        notify(error, { type: "error" });
      }
    };

    if (id !== "new") {
      getTask();
    }
  }, []);

  const handleGoBack = () => {
    window.location.href = "";
  };

  const handleUpdateTool = async () => {
    try {
      const data = await updateTool(tool);
      if (data.success) {
        notify("Ferramenta atualizada com sucesso", { type: "success" });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      notify(error, { type: "error" });
    }
  };

  const handleSaveTool = async () => {
    try {
      const data = await createNewTool(tool);
      if (data.success) {
        // console.log(data.data)
        notify("Ferramenta salva com sucesso", { type: "success" });
        setTimeout(() => {
          navigate(`/tool/edit/${data.data.id}`);
        }, 1000);
      }
    } catch (error) {
      notify(error, { type: "error" });
    }
  };

  return (
    <div className="page-container">
      <div className="d-flex align-center justify-content-between w-100">
        <div className="title-and-subtitle">
          <Title>Ferramenta</Title>
          <SubTitle>Edição</SubTitle>
        </div>
        <div className="d-flex gap-2">
          <Button
            color="secondary"
            style={{ height: "44px" }}
            onClick={() => handleGoBack()}
          >
            Voltar
          </Button>
          <Button
            color="success"
            style={{ height: "44px" }}
            onClick={id == "new" ? handleSaveTool : handleUpdateTool}
          >
            Salvar
          </Button>
        </div>
      </div>
      <div className="mt-5 mb-5">
        <Form>
          <Row>
            <Col md={6} lg={8}>
              <Label className="theme-text-color" >Nome</Label>
              <Input
                className="custom-input"
                type="text"
                placeholder="Nome da Ferramenta"
                value={tool.name}
                onChange={(e) => setTool({ ...tool, name: e.target.value })}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6} lg={8} className="mt-3">
              <FormGroup check>
                <Label check className="gray-text-subtitle">
                  <Input
                    type="checkbox"
                    checked={tool?.showOnPanel || false}
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      setTool((prevStatus) => ({
                        ...tool,
                        showOnPanel: isChecked,
                      }));
                    }}
                  />{" "}
                  Mostrar no Painel
                </Label>
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
}

export default ToolsEdit;
